/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontSocial_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHead_viewer$ref: FragmentReference;
export type StorefrontHead_viewer = {|
  +$fragmentRefs: StorefrontSocial_viewer$ref,
  +$refType: StorefrontHead_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontHead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2d05f21453267818c21dab5d8922a2a2';
module.exports = node;
